import React, { useEffect, useState } from 'react';
import SolutionCalc from './components/solutionCalc/SolutionCalc';

import {
  Paper,
  MainTitle,
  MainCalWrapper,
  MainCalc,
  MainInput,
  MainActions,
  MainLabel,
  Hr,
} from './styled/stylezz';

const App = () => {
  const [inputA, setInputA] = useState('');
  const [inputB, setInputB] = useState('');
  const [answer, setAnswer] = useState(null);
  const [solutionShow, setSolutionShow] = useState(false);

  useEffect(() => {
    const answer = +inputA * +inputB;
    setAnswer(answer);
  }, [inputA, inputB]);
  const handleSolution = () => {
    setSolutionShow(true);
  };

  const handleCleanInput = () => {
    setInputA('');
    setInputB('');
    setAnswer();

    setSolutionShow(false);
  };

  return (
    <React.Fragment>
      <Paper>
        <MainTitle>Калькулятор</MainTitle>
        <MainCalWrapper>
          <span style={{ fontSize: '20px' }}>Введите данные:</span>
          <Hr />

          <MainCalc style={{ justifyContent: 'center', columnGap: '5%' }}>
            <MainLabel>
              a ={' '}
              <MainInput
                type="text"
                placeholder="0"
                value={inputA}
                onChange={(e) => {
                  setInputA(
                    e.target.value.replace(/[^\d\-]|\b-/, '').slice(0, 8),
                  );
                }}
              ></MainInput>
            </MainLabel>
            <MainLabel style={{ fontSize: '2em' }}> &times;</MainLabel>
            <MainLabel>
              b ={' '}
              <MainInput
                value={inputB}
                placeholder="0"
                onChange={(e) =>
                  setInputB(
                    e.target.value.replace(/[^\d\-]|\b-/, '').slice(0, 8),
                  )
                }
              ></MainInput>
            </MainLabel>
          </MainCalc>
          <Hr />

          <MainActions>
            <button onClick={handleSolution}>Решение</button>
            <button onClick={handleCleanInput}>Сбросить</button>
          </MainActions>
        </MainCalWrapper>

        {solutionShow && (
          <SolutionCalc inputA={inputA} inputB={inputB} answer={answer} />
        )}
      </Paper>
    </React.Fragment>
  );
};

export default App;
